import React from 'react';
import { Linking } from 'react-native';
import { IconButton } from '@material-ui/core';


const styles = {
  link: { textDecoration: 'none' },
};

const A = ({ children, ...props }) => <a {...props}>{children}</a>;

const TouchableExternalLink = ({
  url, children, style = {}, containsIcon = false,
}) => {
  const handlePress = () => Linking.openURL(url);

  // The purpose of TouchableWithoutFeedback is just to stop propagating
  // press events to parents
  // The View in the middle exists because otherwise TouchableWithoutFeedback
  // would render the inner link unclickable.

  const Element = containsIcon ? IconButton : A;
  return (
    <Element
      href={url}
      accessibilityrole='link'
      accessible={true.toString()}
      target='_blank'
      rel='noreferrer noopener'
      style={{ ...styles.link, ...style }}
    >
      { children }
    </Element>
  );
};

export default TouchableExternalLink;
